export default __webpack_public_path__ + "static/media/smart-operation.a0e76a5d.svg";